import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const interactiveStore = useInteractiveStore();
  const globalStore = useGlobalStore();
  // тут ключ добавлен только для отключения каптчи (нет ключа, работаем без каптчи)
  const key = import.meta.env?.VITE_CAPTCHA_KEY;
  if (!key || interactiveStore.isPageSpeedBot) return;
  function init() {
    const script = document.createElement('script');
    script.src =
      'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=onloadFunction';
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
    script.onload = function () {
      globalStore.setIsCaptcha(!!key);
    };
  }
  interactiveStore.addFunction(init);
});
